"use strict";

exports.__esModule = true;
exports.SubscriptionAdapterStatus = void 0;

var _core = require("@resolve-js/core");

var SubscriptionAdapterStatus;
exports.SubscriptionAdapterStatus = SubscriptionAdapterStatus;

(function (SubscriptionAdapterStatus) {
  SubscriptionAdapterStatus["Initializing"] = "initializing";
  SubscriptionAdapterStatus["Connecting"] = "connecting";
  SubscriptionAdapterStatus["Connected"] = "connected";
  SubscriptionAdapterStatus["Ready"] = "ready";
  SubscriptionAdapterStatus["Closed"] = "closed";
})(SubscriptionAdapterStatus || (exports.SubscriptionAdapterStatus = SubscriptionAdapterStatus = {}));
//# sourceMappingURL=types.js.map